import { getErrorMessage } from '../../utils/errorMessage';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { getDeviceId } from '../../utils/deviceId';

const client = axios.create({ baseURL: API_BASE_URL, timeout: 10000 });
client.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['X-Xiaoying-Device-ID'] = getDeviceId();
  return config;
});

function unwrap(response) {
  const payload = response?.data;
  if (Number(payload?.code) === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  if (!payload || Number(payload.code) !== 200) {
    const error = new Error(payload?.message || '奖励服务暂不可用');
    error.code = payload?.data?.error_code || payload?.code;
    throw error;
  }
  return payload.data;
}

export async function redeemCode(code) { return unwrap(await client.post('/reward/redeem', { code })); }
export async function getRedeemHistory() { return unwrap(await client.get('/reward/redeem/history')); }
export function rewardApiError(error, fallback) { return getErrorMessage(error, fallback); }
